<template>
  <v-app-bar id="opendataAppBar" app color="#496277" class="white--text">
    <v-img
      alt="Logo CépiDc"
      class="shrink mr-2"
      contain
      src="@/assets/logocepidc.png"
      transition="scale-transition"
      width="260"
    />
    <v-toolbar-title>
      {{ $t("data_query_on_cause_of_death_statistics") }}
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-menu offset-y attach="#opendataAppBar">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          depressed
          v-bind="attrs"
          v-on="on"
          style="text-transform: none"
          color="#496277"
          class="white--text"
        >
          {{ $t("language") }}
          <v-icon>{{ mdiMenuDown }}</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, i) in languages"
          :key="i"
          @click="changeLocale(item.text)"
        >
          <v-list-item-content>
            <v-list-item-title v-text="$i18n.t(item.text)"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import { mdiMenuDown } from "@mdi/js";

export default {
  name: "TopAppBar",
  components: {},
  props: {},
  data: function() {
    return {
      languages: [{ text: "fr-FR" }, { text: "en-GB" }],
      mdiMenuDown: mdiMenuDown
    };
  },
  computed: {},
  methods: {
    changeLocale(locale) {
      this.$vuetify.lang.current = locale.split("-")[0];
      this.$i18n.locale = locale;
    }
  }
};
</script>
<style>
@import "../assets/styles/main.css";
</style>
